import { withSchema } from '@graphistry/falcor-react-schema';
import { createAppRouter } from '@graphistry/viz/src/router/falcor';


export function whitelistClientAPIRoutes(model) {
    const routes = withClientAPIRoutes(() => null)
        .schema({
            get(...paths) {
                return model.get(...paths)._toJSONG();
            },
            set(json) {
                return model.set({ json })._toJSONG();
            },
            call(path, args, suffixes, paths) {
                return model.call(path, args, suffixes, ...paths)._toJSONG();
            }
        })
        .toArray();
    const AppRouter = createAppRouter({ bufferTime: 10, streaming: true }, routes);

    return function getDataSource() {
        return new AppRouter();
    };
}

const withClientAPIRoutes = withSchema((QL, { get, set }, services) => {
    const callFn = { call: services.call };
    const readOnly = { get: services.get };
    const writeOnly = { set: services.set };
    const readWrite = { ...readOnly, ...writeOnly };
    return QL`{
        workbooks: { open: ${readOnly} },
        workbooksById: {
            [{keys: workbookIds}]: {
                id: ${readOnly},
                save: ${callFn},
                views: { current: ${readOnly} },
                viewsById: {
                    [{keys: viewIds}]: {
                        tick: ${callFn},
                        pruneOrphans: ${writeOnly},
                        ['id', 'toolbar']: ${readOnly},
                        ['columns', 'filters', 'exclusions']: {
                            add: ${callFn},
                            reset: ${callFn}
                        },
                        toolbars: {
                            [{keys}]: {
                                visible: ${writeOnly}
                            }
                        },
                        panels: {
                            ['left', 'right', 'bottom']: ${writeOnly}
                        },
                        encodings: {
                            [{keys: componentType}]: {
                                ['icon', 'size', 'color', 'axis']: ${writeOnly}
                            },
                            defaults: {
                                [{keys: componentType}]: {
                                    ['icon', 'size', 'color', 'axis']: ${writeOnly}
                                }
                            }
                        },
                        componentsByType: {
                            [{keys: componentType}]: {
                                rows: {
                                    filter: ${callFn}
                                }
                            }
                        },
                        ['filters', 'scene', 'labels', 'layout', 'exclusions', 'inspector', 'histograms']: {
                            controls: {
                                [{integers}]: {
                                    selected: ${writeOnly}
                                }
                            }
                        },
                        camera: {
                            zoom: ${writeOnly},
                            center: {
                                ['x', 'y', 'z']: ${writeOnly}
                            }
                        },
                        layout: { options: { [{keys}]: { [{keys}]: { value: ${writeOnly} } } } },
                        labels: {
                            ['background', 'foreground']: { color: ${writeOnly} },
                            ['opacity', 'enabled', 'poiEnabled', 'poiLabelEnabled', 'poiMax', 'propertiesEnabled', 'showActions', 'inspectorEnabled', 'highlightEnabled', 'shortenLabels']: ${writeOnly}
                        },
                        scene: {
                            bg: {
                                color: ${writeOnly},
                                image: {['blendMode', 'width', 'height', 'url']: ${writeOnly}},
                                gradient: {['kind', 'position', 'stops']: ${writeOnly}}
                            },
                            fg: {
                                blendMode: ${writeOnly}
                            },
                            logo: {
                                ['url', 'autoInvert', 'position']: ${writeOnly},
                                dimensions: {['maxWidth', 'maxHeight']: ${writeOnly}},
                                crop: {['top', 'left', 'bottom', 'right']: ${writeOnly}},
                                padding: {['top', 'left', 'bottom', 'right']: ${writeOnly}},
                                style: {['brightness', 'contrast', 'grayscale', 'hueRotate', 'opacity', 'saturate']: ${writeOnly}}
                            },
                            page: {
                                ['favicon', 'title']: ${writeOnly}
                            },
                            renderer: {
                                showArrows: ${writeOnly},
                                background: { color: ${writeOnly} },
                                points: {
                                    ['opacity', 'scaling', 'neighborhoodHighlight', 'neighborhoodHighlightHops']: ${writeOnly}
                                },
                                edges: {
                                    ['opacity', 'scaling', 'curvature']: ${writeOnly}
                                }                                
                            },
                            simulating: ${writeOnly}
                        },
                        selection: { setExternal: ${callFn}},
                        highlight: { setExternal: ${callFn}}
                    }
                }
            }
        }
    }`;
});
